import { Box } from "@mui/material";
import React from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { HeroContent } from "./HeroContent";
import { HeroGraphic } from "./HeroGraphic";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      maxWidth: 1280,
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: theme.spacing(8),
      paddingLeft: theme.spacing(8),
      position: "relative",
      marginLeft: "auto",
      marginRight: "auto",
      boxSizing: "border-box",
      [theme.breakpoints.down(1200)]: {
        gap: theme.spacing(4),
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
      },
      [theme.breakpoints.down('lg')]: {
        flexDirection: "column-reverse",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        gap: theme.spacing(4),
      },
      [theme.breakpoints.down('md')]: {
        flexDirection: "column-reverse",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(4),
        gap: theme.spacing(4),
      },
    },
  })
);

export const HeroSection: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <HeroContent />
      <HeroGraphic />
    </Box>
  );
};
